import { render } from "./MyIdCode.vue?vue&type=template&id=2493b9cd&scoped=true"
import script from "./MyIdCode.vue?vue&type=script&lang=js"
export * from "./MyIdCode.vue?vue&type=script&lang=js"

import "./MyIdCode.vue?vue&type=style&index=0&id=2493b9cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2493b9cd"]])

export default __exports__